const list = {
  // =================================================================================================================
  components() {
    return [
      // ===========[ 날짜 관련 ]==========
      {
        component: "search-year",
        label: "평가연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          gridTemplateColumns: "114px 178px",
          xlWidthFull: true,
        },
      },
      {
        component: "search-start-end",
        label: "평가일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
          gridTemplateColumns: "114px 1fr",
        },
      },
      {
        component: "search-check-group",
        label: "중요위험",
        value: "importantRisk",
        query: { ck_l: "checkList" },
        options: {
          list: [
            { text: "Y", value: "Y" },
            { text: "N", value: "N" },
          ],
          selectMaxCount: 2,
          default: [],
          gridTemplateColumns: "114px 178px",
        },
      },
      {
        component: "search-start-end",
        label: "결재완료일",
        value: "approvalDate",
        query: { as: "startDate", ae: "endDate" },
        options: {
          default: { sd: "", ed: "" },
          gridTemplateColumns: "114px 1fr",
        },
      },
      {
        component: "empty-space",
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
          gridTemplateColumns: "114px 1fr",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["사업장명", "구분1", "중요위험", "평가일", "대분류", "중분류", "소분류"],
          gridTemplateColumns: "114px 1fr",
        },
      },
      {
        component: "search-keyword",
        label: "대분류",
        value: "대분류",
        query: { g_1: "keyword" },
        options: {
          default: "",
        },
      },
      {
        component: "search-keyword",
        label: "중분류",
        value: "중분류",
        query: { g_2: "keyword" },
        options: {
          default: "",
        },
      },
      {
        component: "search-keyword",
        label: "소분류",
        value: "소분류",
        query: { g_3: "keyword" },
        options: {
          default: "",
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    // 중요위험
    if (search.importantRisk && search.importantRisk.length > 0) {
      conditions.push({ key: "body.위험성평가표.중요위험", operator: "IN", value: search.importantRisk });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "구분1",
        key: "boardId",
      },
      {
        name: "구분2",
        key: "body.공정분류.구분",
      },
      {
        name: "구분3",
        key: "body.위험성평가구분",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "팀(업체)명",
        key: "body.위험성평가정보.팀",
      },
      {
        name: "공장명",
        key: "body.공정분류.raw.공장명",
      },
      {
        name: "대분류",
        key: "body.공정분류.raw.대분류",
      },
      {
        name: "중분류",
        key: "body.공정분류.raw.중분류",
      },
      {
        name: "소분류",
        key: "body.공정분류.raw.소분류",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "중요위험",
        key: "body.위험성평가표.중요위험",
      },
      {
        name: "공동작성유무",
        key: "body.공동작성.공동작성여부",
      },
      {
        name: "위험도",
        key: "body.위험성평가표.위험도"
      },
      {
        name: "평가일",
        key: "body.위험성평가정보.평가일자",
      },
      {
        name: "아차사고",
        key: "body.공정분류.아차사고",
      },
      {
        name: "결재완료일",
        key: "updated_at",
      },
    ];
  },

  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 0) {
          return value.board_id === 813 ? "직영" : "수급업체";
        } else if (index === 11) /* 공동작성유무 */ {
          const body = func.getContent(value);
          const 공동작성여부 = (body && body.공동작성 && body.공동작성.공동작성여부) || "";
          if (공동작성여부 === "N") {
            return "N - DKS 위험성평가 신규작성 필요"
          }
          return 공동작성여부;
        } else if (index === 15) /* 결재완료일 */ {
          // 결재승인 상태일 때에만 시간을 표시해야 한다
          if (value.document_status.code === 'approved') {
            return (value.post && value.post.updated_at) ? new Date(value.post.updated_at).format("yyyy-MM-dd") : "";
          } else {
            return "-";
          }
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {
      //
    }
    return "";
  },

  getSearchKeyValue: (/* nav */) => {},
  getSearchKeyword: (/* nav */) => {},
};

export default list;
